import { myErrorService } from '../../front/ErrorService/ErrorService.connected';
import { myMessageService } from '../../internal/MessageService/MessageService.connected';
import { createCalloutMutationService } from './CalloutMutationService.impl';

export const myCalloutMutationService = createCalloutMutationService({
  services: {
    errorService: myErrorService,
    messageService: myMessageService
  }
});
